import React from "react";
import CommonModal from "../../../components/Common/CommonModal";
import CommonButton from "../../../components/buttons/CommonButton";
import CommonInput from "../../../components/forms/CommonInput";
import CommonSelect from "../../../components/forms/CommonSelect";
import { handleChange } from "../../../helpers/handleFormChanges";
import PropTypes from "prop-types";
import useTipos from "../../../hooks/common/useTipos";

function JornadaModal({ isOpen, setIsOpen, valuesHook, novo, salvaJornada }) {
  const { values, setValues } = valuesHook;
  const tiposHorasSemanais = useTipos("tipos_horas_semanais");
  const tiposIntervalos = useTipos("tipos_intervalos");

  return (
    <CommonModal
      title={values.uid ? "Editar jornada" : "Cadastrar jornada"}
      is_open_modal={isOpen}
      set_is_open_modal={setIsOpen}
      size="md"
      buttons={
        values.uid ? (
          <CommonButton
            key={`salvar-jornada`}
            onClick={() => {
              salvaJornada(novo);
            }}
            color="success"
          >
            Salvar
          </CommonButton>
        ) : (
          <CommonButton
            onClick={() => {
              salvaJornada(novo);
            }}
            color="success"
          >
            Cadastrar
          </CommonButton>
        )
      }
    >
      <div className="row">
        <div className="col-md-12 mb-3">
          <CommonInput
            label="Descrição"
            id="descricao"
            value={values.descricao}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            required
          />
        </div>
      </div>
      <div className="row">
        <div className="col-md-8 mb-3">
          <CommonSelect
            label="Horas semanais totais"
            id="horasSemanais"
            value={values.horasSemanais}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={tiposHorasSemanais.map((horasSemanais) => ({
              text: horasSemanais.valor,
              id: horasSemanais.chave,
            }))}
            placeholder="Selecione uma quantidade"
            required
          />
        </div>
        <div className="col-md-4 mb-3">
          <CommonSelect
            label="Intervalo (min)"
            id="intervalo"
            value={values.intervalo}
            onChange={(e) => {
              handleChange(e, values, setValues);
            }}
            data={tiposIntervalos.map((intervalos) => ({
              text: intervalos.valor,
              id: intervalos.chave,
            }))}
            placeholder="Selecione"
            required
          />
        </div>
      </div>
      <div className="row">
        <table id="datatable-modal" className="table">
          <thead>
            <tr>
              <th>Dia da semana</th>
              <th>Entrada</th>
              <th>Saída</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Segunda-feira</td>
              <td>
                <CommonInput
                  id="entrada1"
                  value={values.entrada1}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
              <td>
                <CommonInput
                  id="saida1"
                  value={values.saida1}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
            </tr>
            <tr>
              <td>Terça-feira</td>
              <td>
                <CommonInput
                  id="entrada2"
                  value={values.entrada2}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
              <td>
                <CommonInput
                  id="saida2"
                  value={values.saida2}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
            </tr>
            <tr>
              <td>Quarta-feira</td>
              <td>
                <CommonInput
                  id="entrada3"
                  value={values.entrada3}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
              <td>
                <CommonInput
                  id="saida3"
                  value={values.saida3}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
            </tr>
            <tr>
              <td>Quinta-feira</td>
              <td>
                <CommonInput
                  id="entrada4"
                  value={values.entrada4}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
              <td>
                <CommonInput
                  id="saida4"
                  value={values.saida4}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
            </tr>
            <tr>
              <td>Sexta-feira</td>
              <td>
                <CommonInput
                  id="entrada5"
                  value={values.entrada5}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
              <td>
                <CommonInput
                  id="saida5"
                  value={values.saida5}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
            </tr>
            <tr>
              <td>Sábado</td>
              <td>
                <CommonInput
                  id="entrada6"
                  value={values.entrada6}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
              <td>
                <CommonInput
                  id="saida6"
                  value={values.saida6}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
            </tr>
            <tr>
              <td>Domingo</td>
              <td>
                <CommonInput
                  id="entrada7"
                  value={values.entrada7}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
              <td>
                <CommonInput
                  id="saida7"
                  value={values.saida7}
                  onChange={(e) => {
                    handleChange(e, values, setValues);
                  }}
                  required
                  type="time"
                />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </CommonModal>
  );
}

JornadaModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  setIsOpen: PropTypes.func.isRequired,
  valuesHook: PropTypes.shape({
    values: PropTypes.object.isRequired,
    setValues: PropTypes.func.isRequired,
  }).isRequired,
  novo: PropTypes.bool.isRequired,
  salvaJornada: PropTypes.func.isRequired,
};

export default JornadaModal;
